import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { PageMainLabel } from 'app/components/SHLabel';
import styled from 'styled-components';
import Cookies from 'js-cookie';
import ImageDashboard from './imageDashboard';

type Props = {};

const ImageManagement = (props: Props) => {
  const userType = Cookies.get('userType');
  const breadCrumbItems = [
    {
      id: '',
      text: userType === 'COACH' ? 'Showyeda coach' : 'Showyeda admin',
      disabled: true,
    },
    {
      id: userType === 'COACH' ? '/coach/settings/' : '/admin/settings',
      text: 'Settings',
    },
    {
      id:
        userType === 'COACH'
          ? '/coach/background-images'
          : '/admin/background-images',
      text: 'Background Images',
      disabled: true,
    },
  ];

  return (
    <CommonPageWrapper>
      <HeadingWrapper>
        <PageMainLabel>Background Image Management</PageMainLabel>
        <CustomBreadCrumb preData={breadCrumbItems} />
      </HeadingWrapper>
      <MainContent>
        <ContentLayout>
          <ImageDashboard />
        </ContentLayout>
      </MainContent>
    </CommonPageWrapper>
  );
};

export default ImageManagement;

const MainContent = styled.section`
  margin-top: 19px;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ContentLayout = styled.div`
  margin-top: 13px;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;
